import { useEffect, useState } from 'react';

import { connect, useDispatch } from 'react-redux';
import { gatewayMasterActions } from '../../store/reducers/gateway-master';
import MasterComponent from '../../common/MasterComponent';

import AddGateway from './addGateway';

import { ReactComponent as DownloadIcon } from '../../assets/icons/main/download-icon.svg';

import PopUp from '../../components/Popup';
import Chip from '@mui/material/Chip';
import { useNavigate, useOutletContext } from 'react-router-dom';
import CardComponent from '../../components/Card';
import { ReactComponent as GatewayIcon } from '../../assets/icons/main/gateway-icon.svg';
import { Box, IconButton, Typography, Stack, Grid, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';

import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { sentenceCase } from 'change-case';
import axiosClient from '../../store/api/axiosClient';
import useNotification from '../../common/notification';
import { gatewayDetailsDefault } from './form';
import { apiPath } from '../../utils/api-contants';
import { GridValueGetterParams } from '@mui/x-data-grid';

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { GatewayDataRequestPayloadTypes } from '../../store/models/gateway-master-service';
import { get, isEmpty } from 'lodash';
import { palette } from '../../theme/palette';

const defaultPopupState: any = {
  show: false,
  title: '',
  message: '',
  confirmLabel: '',
  cancelLabel: '',
  confirmation: true,
  icon: '',
  onConfirm: null,
  cancel: true,
};

const defaultGatewayState: any = {
  gateway_name: '',
  cidr_to_scan: '',
};

const Styles = {
  downloadIcon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
};

interface GatewayMasterTypes {
  isGatewayMasterDataLoading: boolean;
  gatewayMasterData: Array<any>;
  gatewayMasterDataTotalRowCount: number;
  gatewayMasterDataPageNumber: number;
  isAddGatewaySuccess: boolean;
  isAddGatewayError: boolean;
  ontologyData: any;
  isRemoveGatewaySuccess: boolean;
  isRemoveGatewayError: boolean;
  ontologyMgmntData: any;
  gatewayMasterMessage: boolean;
  gatewayMasterDataError: boolean;
  searchItem: string;
  settingsData: Array<any>;
}

const GatewayMaster = ({
  isGatewayMasterDataLoading,
  gatewayMasterData,
  gatewayMasterDataTotalRowCount,
  gatewayMasterDataPageNumber,
  isAddGatewaySuccess,
  isAddGatewayError,
  ontologyData,
  isRemoveGatewaySuccess,
  isRemoveGatewayError,
  ontologyMgmntData,
  gatewayMasterMessage,
  gatewayMasterDataError,
  searchItem,
  settingsData
}: GatewayMasterTypes) => {
  const tabScreen = useMediaQuery('(max-width:830px)');
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const [msg, sendNotification] = useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [gatewayData, setGatewayData] = useState<any>(gatewayDetailsDefault);
  const [gatewayTagsData, setGatewayTagsData] = useState<any>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [gatewayList, setGatewayList] = useState<any>([]);
  const [ontologyId, setOntologyId] = useState<any>();
  const [popupData, setPopupData] = useState<any>(defaultPopupState);
  const [confirmPopup, setConfirmPopup] = useState<any>(false);
  const [editOntoData, setEditOntoData] = useState<any>([]);
  const [confirmTitle, setConfirmTitle] = useState<any>('Are you sure to delete this gateway?');
  const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });

  useEffect(() => {
    if (gatewayMasterData && gatewayMasterData.length > 0) {
      setGatewayList(
        gatewayMasterData.map((item: any) => {
          return {
            ...item,
            id: item.gateway_id,
            ontologyList: getOntologyData(item.onto_manage_id),
            gateway_tags:
              item.gateway_tags && item.gateway_tags.length > 0
                ? item.gateway_tags.map((val: any, index: any) => {
                  return { ...val, id: index + 1 };
                })
                : [],
          };
        })
      );
    } else {
      setGatewayList([]);
    }
  }, [gatewayMasterData, ontologyMgmntData]);

  useEffect(() => {
    if (isAddGatewaySuccess || isRemoveGatewaySuccess) {
      dispatchGatewayDataRequest({
        limit: DEFAULT_PAGE_SIZE,
        page:
          isRemoveGatewaySuccess && gatewayMasterData.length === 1 && gatewayMasterDataPageNumber !== 1
            ? gatewayMasterDataPageNumber - 1
            : gatewayMasterDataPageNumber,
        onto_manage_id: ontologyId,
      });
    }
  }, [isAddGatewaySuccess, isRemoveGatewaySuccess]);

  const handleDelete = (payload: any) => {
    setConfirmTitle(
      payload.data_transfer_status && payload.data_transfer_status.toLowerCase() === 'provisioned'
        ? 'Are you sure you want to delete the Provisioned Gateway?'
        : 'Are you sure to delete this gateway?'
    );
    setGatewayData(payload);
    setConfirmPopup(true);
  };

  const getOntologyData = (ontoId: any) => {
    if (ontologyMgmntData.length > 0) {
      let tempOntoData: any = [];
      restartTheLoop: while (true) {
        for (const item of ontologyMgmntData) {
          if (item.onto_manage_id == ontoId) {
            tempOntoData.unshift(item);
            ontoId = item.parent_id;
            continue restartTheLoop;
          }
        }
        break;
      }

      tempOntoData.map((item: any) => {
        let getLevelName = ontologyData.filter((data: any) => {
          return data.id === item.onto_level_number;
        })[0];

        return {
          ...item,
          level_name: getLevelName?.level_name || '',
        };
      });
      return tempOntoData;
    }
    return [];
  };

  const handlePopupActions = (data: any, type: any) => {
    if (type === 'delete_confirm') {
      dispatch(gatewayMasterActions.removeGatewayRequest(gatewayData));
      setConfirmPopup(false);
      setGatewayData(gatewayDetailsDefault);
    } else if (type === 'delete_close') {
      setConfirmPopup(false);
      setGatewayData(gatewayDetailsDefault);
    } else if (type === 'success_close') {
      setPopupData({ ...defaultPopupState, show: false });
      dispatch(gatewayMasterActions.resetLoadingState());
    } else if (type === 'ontology_warning_close') {
      setPopupData({ ...defaultPopupState, show: false });
    } else if (type === 'add_edit_popup') {
      setIsModalOpen(false);
      setIsEdit(false);
      setGatewayData(gatewayDetailsDefault);
      setGatewayTagsData([]);
    }
  };

  const handleSearch = () => {
    Navigate('/assets/gateways/OTAsset');
  };

  const successAlertModal = () => {
    Navigate('/assets/ontology');
  };

  const onModalOpen = () => {
    if (ontologyMgmntData && ontologyMgmntData.length > 0) {
      setIsModalOpen(true);
    } else {
      setPopupData({
        show: true,
        title: 'Ontologies are not present',
        message: 'Please add ontology before adding Gateway?',
        confirmLabel: 'Go to Ontology Management',
        cancelLabel: 'Cancel',
        confirmation: true,
        icon: <AlertIcon color={palette.warning.main} />,
        onConfirm: successAlertModal,
        cancel: true,
        onClose: () => handlePopupActions({}, 'ontology_warning_close'),
        onCancel: () => handlePopupActions({}, 'ontology_warning_close'),
      });
    }
  };

  const renderAlertModal = () => (
    <PopUp
      title={popupData?.title}
      open={popupData?.show}
      icon={popupData?.icon}
      message={popupData?.message}
      confirmation
      confirmLabel={popupData?.confirmLabel}
      onConfirm={popupData?.onConfirm}
      cancel={popupData?.cancel}
      cancelLabel={popupData?.cancelLabel}
      onCancel={popupData.onCancel ? popupData.onCancel : () => { }}
      onClose={popupData.onClose ? popupData.onClose : () => { }}
      data={popupData.data}
    />
  );

  const getOntoSelectedValue = (e: any) => {
    // const ontoData = gatewayList.filter((items: any) => {
    //   return items.onto_manage_id === e.onto_manage_id
    // })
    dispatchGatewayDataRequest({
      limit: DEFAULT_PAGE_SIZE,
      page: DEFAULT_PAGE_NUMBER,
      onto_manage_id: e?.onto_manage_id,
    });
    setOntologyId(e?.onto_manage_id);
  };

  // const filteredOntologyArray = useMemo(() => {
  //   if (ontologyId > 0) {
  //     const ontoData = gatewayList.filter((item: any) => {
  //       return item?.ontologyList.some((val: any) => val.onto_manage_id === ontologyId);
  //     });
  //     return ontoData;
  //   }
  //   return gatewayList;
  // }, [gatewayList, ontologyId]);

  const pageData: any = get(useOutletContext(), 'outletData', {});
  const themeData: any = useTheme();

  const dispatchGatewayDataRequest = (payload: GatewayDataRequestPayloadTypes) => {
    dispatch(
      gatewayMasterActions.getGatewayDataRequest({
        ...sortingModel,
        search_item: searchItem,
        pageName: get(pageData, 'entity_name', 'Gateway'),
        ...payload
      })
    );
  };

  useEffect(() => {
    dispatchGatewayDataRequest({ limit: DEFAULT_PAGE_SIZE, page: DEFAULT_PAGE_NUMBER });
    dispatch(ontologyMasterActions.getOntologyList(''));
    dispatch(ontologyMasterActions.getOntologyMgmntList(''));
    setOntologyId(0);

    return () => {
      dispatch(gatewayMasterActions.resetGatewayMasterData());
    };
  }, [settingsData]);

  const columns: any = [
    {
      field: 'gateway_name',
      headerName: `${get(pageData, 'entity_name', 'Gateway') + ' Name'}`,
      resizable: false,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 490,
      renderCell: (params: any) => {
        const ontoList =
          params.row.ontologyList && params.row.ontologyList.length
            ? params.row.ontologyList.map((item: any, index: number) =>
              params.row.ontologyList.length > 1 ? (
                index === params.row.ontologyList.length - 1 ? (
                  <small>{item.onto_manage_title} </small>
                ) : (
                  <small>{item.onto_manage_title} / </small>
                )
              ) : (
                <small>{item.onto_manage_title}</small>
              )
            )
            : '';

        return (
          // <div style={{
          //   display: 'flex',
          //   flexDirection: 'column',
          //   justifyContent: 'flex-start',
          //   alignItems: 'center'
          // }}>
          //   <div style={{
          //     display: 'flex',
          //     width: '100%'
          //   }}>
          //     <>{params.value}</>
          //   </div>
          //   <div style={{
          //     display: 'flex',
          //     width: '100%'
          //   }}>
          //     {params.row.ontologyList.map((item: any) => <p>{item.onto_manage_title}/</p>)}
          //   </div>
          // </div>
          <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '450px' }}>
            <Tooltip title={params.value} placement='left' arrow>
              <Typography
                component='p'
                variant='subtitle1'
                sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
              >
                {params?.value} <br />
              </Typography>
            </Tooltip>

            <Tooltip title={ontoList} placement='bottom' arrow>
              <Typography
                component='p'
                variant='subtitle1'
                sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
              >
                {ontoList}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'data_transfer_status',
      headerAlign: 'left',
      align: 'left',
      headerName: 'Data Transfer Status',
      flex: 1,
      resizable: false,
      minWidth: 230,
      renderCell: (params: any) => {
        return (
          <>
            <Chip
              label={sentenceCase(params.value ?? '')} 
              className={params.value === 'not provisioned' ? 'not_provisioned' : params.value}
              variant='outlined'
              sx={{padding:'0px 8px 0px 8px!important', width:'170px'}}
            />
            </>
        );
      },
    },
    {
      field: 'no_controllers',
      headerName: '# of Controllers',
      flex: 1,
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      minWidth: 180,
      sortable: false,
    },
    {
      field: 'provison',
      headerName: 'Provison',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      resizable: false,
      minWidth: 110,
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            <IconButton
              disabled={params.row.data_transfer_status?.toLowerCase() === 'provisioned'}
              onClick={() => {
                axiosClient({
                  url: apiPath.THINGS_GATEWAYS_BASE_URL + '/' + params.row.gateway_id + '/provision', //your url
                  method: 'GET',
                  // responseType: 'blob', // important
                }).then((response) => {
                  // create file link in browser's memory
                  let binaryData = [];
                  binaryData.push(response.data);
                  const href = window.URL.createObjectURL(new Blob(binaryData, { type: 'text/plain' }));

                  // create "a" HTML element with href to file & click
                  const link = document.createElement('a');
                  link.href = href;
                  link.setAttribute('download', 'core.yaml'); //or any other extension
                  document.body.appendChild(link);
                  link.click();

                  // clean up "a" element & remove ObjectURL
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(href);
                  dispatchGatewayDataRequest({
                    limit: DEFAULT_PAGE_SIZE,
                    page: gatewayMasterDataPageNumber,
                  });
                });
              }}
            >
              <DownloadIcon style={{ ...Styles.downloadIcon, color: themeData.palette.custom.light }} />
            </IconButton>
          </>
        );
      },
    },
    // {
    //   field: 'discoverAssets',
    //   headerName: 'Discover Assets',
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   resizable: false,
    //   minWidth: 300,
    //   renderCell: (params: any) => {
    //     return (
    //       <>
    //         <IconButton disabled>
    //           <SearchIcon />
    //         </IconButton>
    //       </>
    //     );
    //   },
    // },
  ];

  const renderFormModal = () => (
    <AddGateway
      isOpen={isModalOpen}
      gatewayData={gatewayData}
      setGatewayData={setGatewayData}
      gatewayTagsData={gatewayTagsData}
      setGatewayTagsData={setGatewayTagsData}
      isEdit={isEdit}
      closeModal={() => handlePopupActions({}, 'add_edit_popup')}
      ontologyData={ontologyData}
      pageData={isEmpty(pageData) ? {} : pageData}
    />
  );
  var pluralize = require('pluralize');
  return (
    <>
      <Box sx={{ display: 'flex', marginBottom: '20px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <CardComponent
              title={`Pending ${pluralize(get(pageData, 'entity_name', 'Gateway'))}`}
              number={
                (() => {
                  const num = gatewayList.filter((value: any) => value.data_transfer_status.toLowerCase() === 'not provisioned').length;
                  return String(num).padStart(2, '0');
                })()
              }
              icon={<GatewayIcon />}
              color={palette.chipInfo.dark}
            />
          </Grid>

          {/*<CardComponent title={'Active with Stop Status'} number={gatewayList.filter((value: any) => (value.data_transfer_status === 'inactive' && value.data_transfer_status === 'running')).length} icon={<GatewayIcon />} color="#D81010" />*/}
          <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <CardComponent
              title={`Provisioning ${pluralize(get(pageData, 'entity_name', 'Gateway'))}`}
              number={
                (() => {
                  const num = gatewayList.filter((value: any) => value.data_transfer_status.toLowerCase() === 'provisioning').length;
                  return String(num).padStart(2, '0');
                })()
              }
              icon={<GatewayIcon />}
              color={palette.warning.main}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <CardComponent
              title={`Provisioned ${pluralize(get(pageData, 'entity_name', 'Gateway'))}`}
              number={
                (() => {
                  const num = gatewayList.filter((value: any) => value.data_transfer_status.toLowerCase() === 'provisioned').length;
                  return String(num).padStart(2, '0');
                })()
              }
              icon={<GatewayIcon />}
              color={palette.success.dark}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <CardComponent
              title={`Total ${pluralize(get(pageData, 'entity_name', 'Gateway'))}`}
              number={String(gatewayList.length).padStart(2, '0')}
              icon={<GatewayIcon />}
              color={palette.secondary.dark}
            />
          </Grid>
        </Grid>
      </Box>
      <MasterComponent
        heading={`List of ${pluralize(get(pageData, 'entity_name', 'Gateway'))}`}
        isLoading={isGatewayMasterDataLoading}
        rows={gatewayList}
        columns={columns}
        isServerPagination
        totalRowCount={gatewayMasterDataTotalRowCount}
        pageNumber={gatewayMasterDataPageNumber}
        onPagination={(pageSize: number, pageNumber: number) => {
          dispatchGatewayDataRequest({
            limit: pageSize,
            page: pageNumber,
            ...(ontologyId && { onto_manage_id: ontologyId }),
          });
        }}
        onSorting={(sortModel: { field: string; sort: string }) => {
          dispatchGatewayDataRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: gatewayMasterDataPageNumber,
            ...(ontologyId && { onto_manage_id: ontologyId }),
            ...sortModel,
          });
          setSortingModel(sortModel);
        }}
        showFilters={true}
        setIsModalOpen={onModalOpen}
        ontologyData={ontologyData}
        ontologyManagement={ontologyMgmntData}
        onOntoFilterChange={getOntoSelectedValue}
        tableHeight={true}
        noRowsOverlay={() => (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            {`No  ${get(pageData, 'entity_name', 'Gateway') + 's'}`}
          </Stack>
        )}
        handleRefresh={() => {
          dispatchGatewayDataRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: gatewayMasterDataPageNumber,
          });
          dispatch(ontologyMasterActions.getOntologyList(''));
          dispatch(ontologyMasterActions.getOntologyMgmntList(''));
        }}
        actionsColumn={{
          delete: {
            onClick: (params: GridValueGetterParams) => handleDelete(params.row),
            isDisabled: (params: GridValueGetterParams) =>
              params.row.data_transfer_status?.toLowerCase() === 'provisioned',
          },
        }}
        showSearch
        searchPlaceholder={`${tabScreen ? get(pageData, 'entity_name', 'Gateway') + ' Name / Status' : get(pageData, 'entity_name', 'Gateway') + ' Name / Data Transfer Status'}`}
        onSearch={(searchValue: string) => {
          dispatchGatewayDataRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            ...(ontologyId && { onto_manage_id: ontologyId }),
            search_item: searchValue,
          });
          dispatch(gatewayMasterActions.onSearchForItem(searchValue));
        }}
      />
      <PopUp
        open={confirmPopup}
        icon={<AlertIcon color={palette.warning.main} />}
        message={confirmTitle}
        cancel={true}
        confirmation={true}
        cancelLabel='No'
        confirmLabel='Yes'
        onConfirm={() => handlePopupActions({}, 'delete_confirm')}
        onClose={() => handlePopupActions({}, 'delete_close')}
        onCancel={() => handlePopupActions({}, 'delete_close')}
      />
      {isModalOpen && renderFormModal()}
      {renderAlertModal()}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  isGatewayMasterDataLoading: state.gatewayMaster.isGatewayMasterDataLoading,
  gatewayMasterData: state.gatewayMaster.gatewayMasterData,
  gatewayMasterDataTotalRowCount: state.gatewayMaster.gatewayMasterDataTotalRowCount,
  gatewayMasterDataPageNumber: state.gatewayMaster.gatewayMasterDataPageNumber,
  isAddGatewaySuccess: state.gatewayMaster.isAddGatewaySuccess,
  isAddGatewayError: state.gatewayMaster.isAddGatewayError,  
  isRemoveGatewaySuccess: state.gatewayMaster.isRemoveGatewaySuccess,
  isRemoveGatewayError: state.gatewayMaster.isRemoveGatewayError,
  gatewayMasterMessage: state.gatewayMaster.gatewayMasterMessage,
  gatewayMasterDataError: state.gatewayMaster.gatewayMasterDataError,
  ontologyMgmntData: state.ontologyMaster.ontologyMgmntData,
  ontologyData: state.ontologyMaster.ontologyData,
  searchItem: state.gatewayMaster.searchItem,
  settingsData: state.settings.settingsData,
});

export default connect(mapStateToProps)(GatewayMaster);
